export default __webpack_public_path__ + "static/media/shape2.f35c6692.svg";